<template>
    <div>
        <view-item v-if="showDisplayForm" :item="selectedType" @success="alertSuccess" @danger="alertDanger"
            @delete-item="deleteType" @cancel="cancel"></view-item>

        <list-items v-else title="Review Types" :items="checkoffTypes" @show-item="showItem" ref="table">
            <b-button block variant="primary" @click="addType" v-if="hasPermissionCreate">
                <img v-b-tooltip.hover :title="$addLabel()" src="@/assets/images/icon/blue-add.svg">
            </b-button>
        </list-items>
    </div>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import utilityMixins from '@/mixins/utilityMixins'
import ListItems from './ListItems'
import ViewItem from './ViewItem'

export default {
    name: 'reviewTypes',
    components: {
        ListItems,
        ViewItem,
    },
    mixins: [popupMixins, permissionsMixins, utilityMixins],
    data: () => {
        return {
            showDisplayForm: false,
        }
    },

    created() {
        this.$store.dispatch('roles/fetchAll')
        this.$store.dispatch('checkoffTypes/fetchAll')
    },
    computed: {
        componentName() { return this.$translate('review_type') },
        checkoffTypes() {
            const types = this.$store.state.checkoffTypes.types
            console.log('types', types)
            return types
        },
        selectedType() {
            const selectedType = this.$store.state.checkoffTypes.selectedType
            console.log('selectedType', selectedType)
            return selectedType
        },
    },
    watch: {
        'selectedType.id': function (to) {
            if (to) this.showDisplayForm = true
        },
    },

    methods: {
        cancel() {
            this.$store.commit('checkoffTypes/SET_NULL_TYPE')
            this.showDisplayForm = false
            this.$store.dispatch('checkoffTypes/fetchAll')
        },

        showItem(id) {
            this.$store.dispatch('checkoffTypes/fetchById', id)
        },

        alertSuccess(action, name, message) {
            this.$store.commit('checkoffTypes/SET_NULL_TYPE')
            this.showDisplayForm = false
            this.genericToast(
                this.componentName,
                action,
                'success',
                `"${name}" ${message}`
            )
        },
        alertDanger(action, message) {
            this.genericToast(
                this.componentName,
                action,
                'danger',
                message,
            )
        },
        addType() {
            this.$store.commit('checkoffTypes/SET_NULL_TYPE')
            this.showDisplayForm = true
        },
    },
}
</script>
<style></style>
